export default {
    data: () => ({
        translations: {
            create: {
                el: "Δημιουργία Πολλαπλού Κουπονιού",
                en: "Create Multiple Coupon",
                it: "Crea Più Coupon"
            },
            analiticalReport: {
                el: "Αναλυτική Αναφορά",
                en: "Analitical Report",
                it: "Rapporto dettagliato"
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            numberOfCoupons: {
                el: "Αριθμός Κουπονιών",
                en: "Number of Coupons",
                it: "Numero di coupon"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            downloadExcel: {
                el: "",
                en: "Download Excel",
                it: ""
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            giftTitle: {
                el: "Όνομα Κουπονιού",
                en: "Coupon name",
                it: "Nome"
            },
            giftDescription: {
                el: "Περιγραφή",
                en: "Coupon Description",
                it: "Descrizione"
            },
            price: {
                el: "Αξία ή Δώρο",
                en: "Value or Gift",
                it: "Prezzo o Ρegalo"
            },
            priceCreate: {
                el: "Τιμή",
                en: "Price",
                it: "Prezzo"
            },
            startDate: {
                el: "Έναρξη",
                en: "Start Date",
                it: "Lancia"
            },
            endDate: {
                el: "Λήξη",
                en: "End Date",
                it: "Fine"
            },
            validDays: {
                el: "Ισχύς Κουπονιών (ημέρες)",
                en: "Validity Period (days)",
                it: "Validità coupon (giorni)"
            },
            masterCoupon: {
                el: "Κωδικός Κύριου Κουπονιού",
                en: "Master Coupon Code",
                it: "Codice Coupon Principale"
            },
            giftCategory: {
                el: "Κατηγορία Δώρου",
                en: "Gift Category",
                it: "Categoria regalo"
            },
            totalCoupons: {
                el: "Σύνολο Kουπονιών",
                en: "Total Coupons",
                it: "Totale Coupon"
            },
            maximum: {
                el: "Αριθμός Κουπονιών",
                en: "Coupon Amount",
                it: "Numero di Coupon"
            },
            validityPeriod: {
                el: "Ημερομηνία Λήξης",
                en: "Expiry date",
                it: "Data di scadenza"
            },
            masterCode: {
                el: "Κωδικός Κύριου Κουπονιού",
                en: "Master coupon code",
                it: "Codice Coupon Principale"
            },
            sendReportRedeemedCouponsReport: {
                el: "Αποστολή Αναφοράς - Εξαργυρωμένα Κουπόνια",
                en: "Send Report - Redeemed Coupons Report",
                it: "Invia Segnalazione - Buoni Riscattati"
            },
            emailAddress1: {
                el: "Email 1",
                en: "Email address 1",
                it: ""
            },
            emailAddress2: {
                el: "Email 2",
                en: "Email address 2",
                it: ""
            },
            emailAddress3: {
                el: "Email 3",
                en: "Email address 3",
                it: ""
            },
            frequencyOfReport: {
                el: "Συχνότητα Αποστολής Αναφοράς",
                en: "Frequency Of Report",
                it: "Frequenza di Invio di Riferimento"
            },
            frequencyOfReportHelp: {
                el: `Επίλεξε πόσο συχνά θέλεις να λαμβάνεις την αναφορά. Τα δεδομένα της αναφοράς θα είναι για το διάστημα από την τελευταία αναφορά που έλαβες.`,
                en: `Set how often you wish to receive this report. Each report will include data since the latest report you received.`,
                it: ""
            },
            sendReportAllCouponsStatusReport: {
                el: "Αποστολή Αναφοράς - Κατάσταση Πολλαπλών Κουπονιών",
                en: "Send Report - All Coupons Status Report ",
                it: "Invia Rapporto - Stato di Più Coupon"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            redeemedStore: {
                el: "Κατάστημα εξαργύρωσης",
                en: "Redeemed Store",
                it: "Negozio di riscatto"
            },
            voucherCode: {
                el: "Κωδικός Εξαργύρωσης",
                en: "Voucher Code",
                it: "codice voucher"
            },
            redeemedAt: {
                el: "Εξαργυρώθηκε στις",
                en: "Redeemed At",
                it: "Riscattato a"
            },
         
        }
    })
};
